module.exports = {
  title: `Jinote`,
  description: `Blog posted about learn, dev, etc.`,
  author: `jinoan`,
  introduction: `Junior AI Engineer`,
  siteUrl: `https://jinoan.netlify.app`, // Your blog site url
  social: {
    twitter: ``, // Your Twitter account
    github: `jinoan`, // Your GitHub account
    medium: ``, // Your Medium account
    facebook: `h2oinjan`, // Your Facebook account
    linkedin: `jinho-ahn-998503117`, // Your LinkedIn account
  },
  icon: `content/assets/felog.png`, // Add your favicon
  keywords: [`blog`],
  comment: {
    disqusShortName: '', // Your disqus-short-name. check disqus.com.
    utterances: 'jinoan/blog-comment', // Your repository for archive comment
  },
  configs: {
    countOfInitialPost: 10, // Config your initial count of post
  },
  sponsor: {
    buyMeACoffeeId: 'jinoan',
  },
  share: {
    facebookAppId: '', // Add facebookAppId for using facebook share feature v3.2
  },
  ga: 'UA-183475653-1', // Add your google analytics tranking ID
}
